export const THEMES = {
  dark: {
    label: 'Dark',
    description: 'VS Code-inspired dark theme',
    vars: {
      '--app-bg': '#1e1e1e',
      '--app-surface': '#2d2d30',
      '--app-border': '#3c3c3c',
      '--app-text': '#cccccc',
      '--app-text-muted': '#888888',
      '--app-accent': '#007acc',
      '--scrollbar-thumb': '#555555',
      '--scrollbar-thumb-hover': '#777777',
      '--scrollbar-track': 'transparent',
    },
  },
  midnight: {
    label: 'Midnight',
    description: 'Deep blue dark theme',
    vars: {
      '--app-bg': '#0d1117',
      '--app-surface': '#161b22',
      '--app-border': '#30363d',
      '--app-text': '#c9d1d9',
      '--app-text-muted': '#8b949e',
      '--app-accent': '#58a6ff',
      '--scrollbar-thumb': '#30363d',
      '--scrollbar-thumb-hover': '#484f58',
      '--scrollbar-track': 'transparent',
    },
  },
  dracula: {
    label: 'Dracula',
    description: 'Purple-accented dark theme',
    vars: {
      '--app-bg': '#282a36',
      '--app-surface': '#21222c',
      '--app-border': '#44475a',
      '--app-text': '#f8f8f2',
      '--app-text-muted': '#6272a4',
      '--app-accent': '#bd93f9',
      '--scrollbar-thumb': '#44475a',
      '--scrollbar-thumb-hover': '#6272a4',
      '--scrollbar-track': 'transparent',
    },
  },
  light: {
    label: 'Light',
    description: 'Clean light theme',
    vars: {
      '--app-bg': '#f5f5f5',
      '--app-surface': '#ffffff',
      '--app-border': '#e0e0e0',
      '--app-text': '#333333',
      '--app-text-muted': '#888888',
      '--app-accent': '#007acc',
      '--scrollbar-thumb': '#c0c0c0',
      '--scrollbar-thumb-hover': '#999999',
      '--scrollbar-track': 'transparent',
    },
  },
};

export const DEFAULT_THEME = 'dark';
export const THEME_STORAGE_KEY = 'dry_theme';
